import type { ReactNode } from "react";
import { classes } from "../classes.ts";
import styles from "./KeyHint.module.css";

export function KeyHint({ children, onInk = false }: { readonly children: ReactNode; readonly onInk?: boolean }) {
  return <kbd className={classes(styles.key, onInk && styles.onInk)}>{children}</kbd>;
}
